import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const createRateContract = createAsyncThunk(
  "rateContract/create",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.createContract}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getRateContractById = createAsyncThunk(
  "rateContract/fetch/id",
  async (id: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getContractById}`;
    url = url.replace(":contractId", id);
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllRateContract = createAsyncThunk(
  "rateContract/fetch/all",
  async (id: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getAllContract}`;
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getRateContractPagination = createAsyncThunk(
  "rateContract/fetch/pagination",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getContractPagination;

    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createOrderFromRateContract = createAsyncThunk(
  "rateContract/order/create",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.createOrderFromRateContract}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
